/**
 * RBF0404B40 - 예금계좌상세조회 (계좌비밀번호 검증용)
 */
export const RBF0404B40 = {
  methods: {
    RBF0404B40Call(param) {
      return new Promise(resolve => {
        this.$post(
          "/account/inqury/AcnInqDtlPop",
          param,
          response => {
            resolve(response);
          },
          () => {
            resolve("fail");
          },
          null,
          false,
        );
      });
    },
  },
};

export const RBF0404B40Param = {
  data() {
    return {
      incaKepad: {
        acno0: "",
        acnDsticCd0: "1",
        outItem: {}, //계좌상세조회 outItem
        isPasswordCheck: true, //키패드에서 패스워드 검증 적용 여부
      },
    };
  },
};
